import React from "react";
import { Spinner } from "react-bootstrap";

const TextSpinner = ({ text = "Carregando...", show = true, size = "sm" }) =>
  show && (
    <span>
      <Spinner animation="border" role="status" size={size} />
      {` ${text}`}
    </span>
  );

export default TextSpinner;
